import { useMediaQuery, useTheme } from '@mui/material';
import LayoutBodyWrapper from 'layouts/layout-parts/LayoutBodyWrapper';
import Footer from 'page-sections/dashboards/learning-management/Footer';
import { Fragment, useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router';
import DashboardHeader from '../layout-parts/DashboardHeader';
import DashboardSidebar from './DashboardSidebar';

const DashboardLayout = ({ children }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('lg'));
  const isDesktop = useMediaQuery(theme.breakpoints.up('xl'));
  const location = useLocation();
  const [showSideBar, setShowSideBar] = useState(false);
  const [showMobileSideBar, setShowMobileSideBar] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.key]);

  // let sidebarWidth = "230px";
  let sidebarWidth = '0px';

  const customStyle = {
    // width: `calc(100% - ${showSideBar ? sidebarWidth : "0px"})`,
    width: '100%',
    marginLeft: showSideBar ? sidebarWidth : '0px',
    paddingX: !isDesktop ? '0px' : '220px',
  };

  return (
    <Fragment>
      <DashboardSidebar
        showSideBar={showSideBar}
        showMobileSideBar={showMobileSideBar}
        setShowSideBar={() => setShowSideBar(state => !state)}
        closeMobileSideBar={() => setShowMobileSideBar(false)}
      />
      <DashboardHeader
        setShowSideBar={() => setShowSideBar(state => !state)}
        setShowMobileSideBar={() => setShowMobileSideBar(state => !state)}
      />

      <LayoutBodyWrapper sx={customStyle}>
        {children || <Outlet />}
      </LayoutBodyWrapper>
      <Footer showSideBar={showSideBar} />
    </Fragment>
  );
};

export default DashboardLayout;
